export default "__VITE_ASSET__CFgoRLel__"